/**
 * Date-extensions locale Indonesian [id]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('id', {
    monthNames: ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Ags','Sep','Okt','Nov','Des'],
    dayNames: ['Minggu','Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'],
    dayShortNames: ['Min','Sen','Sel','Rab','Kam','Jum','Sab']
});
